import { render, staticRenderFns } from "./SurveyAnswer.vue?vue&type=template&id=2688a23d&"
import script from "./SurveyAnswer.vue?vue&type=script&lang=js&"
export * from "./SurveyAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports